import { useStorageContext } from '@/contexts/StorageContext'
import { myMapStyles } from './MyMap.styles'

export function MyMap() {
  const storage = useStorageContext()
  return (
<div style={myMapStyles.gmap} >
    <div style={myMapStyles.blockMargin} >
      <div style={myMapStyles.bxYandexViewLayout} >
        <div style={myMapStyles.bxYandexViewMap} >
          <div
              id="BX_GMAP_main"
              style={myMapStyles.bxGoogleMap}>

            <iframe 
            src={storage.barndInfo.map} 
            width="100%" height="351" frameBorder="0" allowFullScreen aria-hidden="false" tabIndex={0}></iframe>

          </div>

        </div>
      </div>
    </div>
  </div>
  )
}